<div class="maintenance flex column">
    <img src="../../assets/img/crewcus-logo" style="max-width: 250px;
    align-self: center;">

    <div>{{'Unfortunately the site is down for a bit of maintenance right now. but soon well be up and ready again.' | translate}}</div>
</div>